import { Component, Input, OnChanges, OnDestroy, OnInit } from '@angular/core';
import { ModalService, GoogleService } from '../../services';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-video-player',
    templateUrl: './video-player.component.html',
    styleUrls: ['./video-player.component.scss']
})
export class VideoPlayerComponent implements OnInit, OnChanges {
    @Input() data: any;
    @Input() download_link: any = undefined;
    @Input() with_play_btn: boolean = false;

    public activeVideo: any = undefined;
    public nextVideo: any = undefined;
    public path: string = environment.assetBasePath + 'videos/';

    public singleVideo: boolean = false;
    public activeIndex: number = 0;
    public videoPlaying: boolean = false;
    public videoFooterEnabled: boolean = false;
    public weAreVisible: boolean = false;

    constructor(private modalSvc: ModalService, private googleSvc: GoogleService) { }

    public ngOnInit(): void {
        document.querySelector('#video-player').addEventListener('play', this.playHandler.bind(this));
        document.querySelector('#video-player').addEventListener('ended', this.endedHandler.bind(this));
        document.querySelector('#video-player').addEventListener('pause', this.pauseHandler.bind(this));
        this.modalSvc.modalVisible.subscribe(data => {
            this.weAreVisible = data;
            // if (!data) {
            //     this.activeVideo = undefined;
            //     // this.weAreVisible = null;
            // }
        });
        this.modalSvc.modalData.subscribe(data => {
            if (data === undefined) {
                this.activeVideo = undefined;
            }
        });
    }

    public ngOnChanges(): void {
        if (this.data.active_video) {
            this.singleVideo = false;
            this.activeVideo = this.data.active_video;
            const videos = this.data.all_videos;
            this.activeIndex = Object.values(videos).findIndex(x => x['title'] === this.activeVideo.title);
            this.setWatchNext();

            if ((this.activeIndex) !== videos.length) {
                this.nextVideo = videos[this.activeIndex];
            } else {
                this.nextVideo = undefined;
            }
        } else {
            this.singleVideo = true;
            this.activeVideo = this.data;
            this.nextVideo = undefined;
        }
    }

    public playVideo(): void {
        (document.querySelector('#video-player') as HTMLVideoElement).play();
    }

    public playHandler(): void {
        this.videoPlaying = true;
    }

    public pauseHandler(): void {
        this.videoPlaying = false;
    }

    public endedHandler(): void {
        if (!this.singleVideo) {
            this.setWatchNext();
        }
    }

    public nextVideoClick(): void {
        // This is not needed anymore.
        // this.setWatchNext();

        const data = {
            active_video: this.data.all_videos[this.activeIndex],
            id: this.data.all_videos[this.activeIndex].id,
            all_videos: this.data.all_videos,
            modal_type: 'video-player',
            parent: this.data.parent
        };

        this.modalSvc.modalData.next(data);
    }

    public setWatchNext(): void {
        this.activeIndex++;
        if (this.activeIndex === this.data.all_videos.length) {
            this.activeIndex = 0;
        }

        for (const i of this.data.all_videos) {
            i.watchNext = false;
        }

        this.data.all_videos[this.activeIndex].watchNext = true;
    }

    public downloadClicked(e, link): void {
        e.preventDefault();
        window.open(link.href, '_blank');
        this.googleSvc.sendGAEventById(link.trackingId);
    }
}
